export default __webpack_public_path__ + "static/media/serpenttransmutation.40e0f3f5.png";